import loadable from '@loadable/component';

import { BoxIndicator } from '@classtinginc/design-system';

const AssignmentReportPage = loadable(() => import('./AssignmentReportPage'), {
  fallback: <BoxIndicator />,
});

export default AssignmentReportPage;
